/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DiscogsReleaseTracklistTracksInnerSubtracksInner } from './DiscogsReleaseTracklistTracksInnerSubtracksInner';
import {
    DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSON,
    DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSONTyped,
    DiscogsReleaseTracklistTracksInnerSubtracksInnerToJSON,
} from './DiscogsReleaseTracklistTracksInnerSubtracksInner';

/**
 * 
 * @export
 * @interface DiscogsReleaseTracklistTracksInner
 */
export interface DiscogsReleaseTracklistTracksInner {
    /**
     * 1-based position in the raw Discogs tracklist, headings and title-less entries included. The recording's `source_id` is `TrackId:<release_id>:<index>`, or `TrackId:<release_id>:<index>-<subtrack index>` for a sub-track -- the id the data platform mints for the same track.
     * @type {number}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    kind: DiscogsReleaseTracklistTracksInnerKindEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    position: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    duration: string;
    /**
     * 
     * @type {Array<DiscogsReleaseTracklistTracksInnerSubtracksInner>}
     * @memberof DiscogsReleaseTracklistTracksInner
     */
    subtracks: Array<DiscogsReleaseTracklistTracksInnerSubtracksInner>;
}


/**
 * @export
 */
export const DiscogsReleaseTracklistTracksInnerKindEnum = {
    Track: 'track',
    Index: 'index',
    Heading: 'heading'
} as const;
export type DiscogsReleaseTracklistTracksInnerKindEnum = typeof DiscogsReleaseTracklistTracksInnerKindEnum[keyof typeof DiscogsReleaseTracklistTracksInnerKindEnum];


/**
 * Check if a given object implements the DiscogsReleaseTracklistTracksInner interface.
 */
export function instanceOfDiscogsReleaseTracklistTracksInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "duration" in value;
    isInstance = isInstance && "subtracks" in value;

    return isInstance;
}

export function DiscogsReleaseTracklistTracksInnerFromJSON(json: any): DiscogsReleaseTracklistTracksInner {
    return DiscogsReleaseTracklistTracksInnerFromJSONTyped(json, false);
}

export function DiscogsReleaseTracklistTracksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsReleaseTracklistTracksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'kind': json['kind'],
        'title': json['title'],
        'position': json['position'],
        'duration': json['duration'],
        'subtracks': ((json['subtracks'] as Array<any>).map(DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSON)),
    };
}

export function DiscogsReleaseTracklistTracksInnerToJSON(value?: DiscogsReleaseTracklistTracksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'kind': value.kind,
        'title': value.title,
        'position': value.position,
        'duration': value.duration,
        'subtracks': ((value.subtracks as Array<any>).map(DiscogsReleaseTracklistTracksInnerSubtracksInnerToJSON)),
    };
}

